import { forwardRef, type Ref, type SVGProps } from "react";
const IconBusSideOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 5H3a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h2.14a4 4 0 0 0 7.72 0h6.28a4 4 0 0 0 7.72 0H29a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2m-8 2h8v6h-8ZM3 7h16v6H3Zm6 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2m14 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2m6-3h-2.14a4 4 0 0 0-7.72 0h-6.28a4 4 0 0 0-7.72 0H3v-7h26z" />
  </svg>
);
const ForwardRef = forwardRef(IconBusSideOutlineSVG);
ForwardRef.displayName = "IconBusSideOutline";
export { ForwardRef as IconBusSideOutline };
